<template>
  <div class="container">
    <!-- 顶部导航栏组件 -->
    <Titles></Titles>
    <div class="box">
      <!-- 广告 -->
      <advertisement />
      <!-- 头部菜单组件 -->
      <InteriorH :name="1"></InteriorH>
      <!-- <p>调解指南</p> -->

      <!-- 指南列表 -->
      <div class="lists" v-for="(item, index) in list" :key="index" @click="path(item.id, item.category_id)">
        {{ }}
        <img :src="item.thumbImage.fullImageUrl" alt="">
        <div class="listBox">
          <h5>
            {{ item.title }}
          </h5>
          <span>{{ item.create_time }}</span>
        </div>
      </div>

      <!-- 分页 -->
      <!-- <van-pagination @change="log" v-model="currentPage" :total-items="50" :items-per-page="5" :show-page-size="5">
      </van-pagination> -->
      <van-pagination @change="onChange" v-model="currentPage" :total-items="total" :show-page-size="10"></van-pagination>
    </div>
    <copyright />
  </div>
</template>

<script>
import Titles from '../components/title.vue'
import InteriorH from '../components/interiorH.vue'
import copyright from '../components/copyright.vue'
import axios from 'axios'
export default {
  components: {
    Titles,
    InteriorH,
    copyright
  },
  data() {
    return {
      currentPage: 1,
      upper: '上',
      text: 5,
      total: "",
      list: []

      // {
      //   fullImageUrl:"",
      //   title:"",
      //   post_time:""
      // }
    }
  },
  mounted() {
    this.grtlist()
  },
  methods: {
    // category_id是类型
    async grtlist(value = 1) {
      let res = await axios.post('/api/article/page_list', {
        "current_page": value,
        "category_id": 1
      })
      this.list = res.data.data.records
      this.total = res.data.data.total
    },
    onChange(value) {
      this.grtlist(value);
    },
    // 跳转到详情
    path(article_id, category_id) {
      this.$router.push({ path: "/fingerpostI", query: { article_id, category_id } })
    }
  },

}
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 3rem 1rem 0 1rem;

}

p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
}

.lists {
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.lists img {
  width: 101px;
  height: 72px;
}

.listBox {
  height: 72px;
  width: calc(100% - 118px);
  /* width: 274px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  display: -webkit-box;
  /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
  display: -moz-box;
  /* 老版本语法: Firefox (buggy) */
  display: -ms-flexbox;
  /* 混合版本语法: IE 10 */
  display: -webkit-flex;
  /* 新版本语法: Chrome 21+ */
  display: flex;
  /* 新版本语法: Opera 12.1, Firefox 22+ */
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;


  -webkit-box-pack: justify;
  -moz-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.listBox span {
  text-align: right;
  font-size: 12px;
  color: #94979A;
}


>>>.van-pagination__item--active {
  color: black;
  background-color: #fff;
}

>>>.van-pagination__item:active {
  color: #1989fa;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/fingerpost.vue